import Api from '/core/services/Api';
import browserSignature from 'browser-signature';

export const loginUser = async(email, password) => {
    try {
        const signature = browserSignature();
        
      const response = await Api.post(`users/login`, {
          email: email,
          password: password,
          signature: signature
      });

      return response;
    } catch (error) {
        return Api.technicalError();
    }
};

export const createUserAccount = async(obj) => {
    try {
        const response = await Api.post(`users`, obj);

        return response;
    } catch (error) {
        return Api.technicalError();
    }
}

export const forgotUserPassword = async(obj) => {
    try {
        const response = await Api.post(`user/forgot-password`, obj);

        return response;
    } catch (error) {
        return Api.technicalError();
    }
}

export const fetchUserByResetHash = async(hash) => {
    try {
        const response = await Api.get(`user/reset-code/`+hash);

        return response;
    } catch (error) {
        return Api.technicalError();
    }
}

export const resetPasswordByHash = async(hash, obj) => {
    try {
        const response = await Api.put(`user/reset-password/`+hash, obj);

        return response;
    } catch (error) {
        return Api.technicalError();
    }
}

export const logoutUser = async() => {
    try {
        const response = await Api.put(`user/logout`);

        return response;
    } catch (error) {
        return Api.technicalError();
    }
}

export const activateUserAccount = async(hash) => {
    try {
        const response = await Api.put(`users/activate/`+hash);

        return response;
    } catch (error) {
        return Api.technicalError();
    }
}

export const fetchTwoFaConfig = async(hash) => {
    try {
        const response = await Api.get(`two-fa/config/`+hash);

        return response;
    } catch (error) {
        return Api.technicalError();
    }
}

export const setupTwoFaConfig = async(hash, otp) => {
    try {
        const response = await Api.post(`two-fa/config/`+hash, {
            otp: otp
        });

        return response;
    } catch (error) {
        return Api.technicalError();
    }
}

export const fetchTwoFaChallenge = async(hash) => {
    try {
        const response = await Api.get(`two-fa/challenge/`+hash);

        return response;
    } catch (error) {
        return Api.technicalError();
    }
}

export const sendTwoFaChallenge = async(hash,otp) => {
    try {
        const response = await Api.post(`two-fa/challenge/`+hash, {
            otp: otp
        });

        return response;
    } catch (error) {
        return Api.technicalError();
    }
}
